import { IPersonalInfo } from 'api-paths-cas';
import { countries } from 'platform-data';
export const getCountryOfVisaApplication = (personalInfo: IPersonalInfo): string => {
  if (personalInfo.applyingFromHomeCountry) {
    return countries.find(i => i.nationality === personalInfo.nationality)?.countryName ?? '';
  }

  if (personalInfo.countryOfVisaApplication) return personalInfo.countryOfVisaApplication;

  return (
    countries.find(i => i.nationality === personalInfo.nationality)?.countryName ??
    personalInfo.countryOfVisaApplication ??
    ''
  );
};
